import { BrowserView } from 'components/DeviceDetect'
import Pagination from 'components/Pagination'
import ProductItem from 'components/Widgets/ProductItem'
import React, { Fragment } from 'react'
import useInnerPage from 'store/InnerPageProvider'
import { CategorySale, NoProductFoundDiv } from 'style/Category.style'
import OrderingAndfilters from './OrderingAndFilters'

export default function InnerPageProducts(props) {
  const {
    products: { products, pagination },
    clearFilters,
  } = useInnerPage()
  const { category } = props

  if (Array.isArray(products) && !products.length > 0) {
    return (
      <Fragment>
        <NoProductFoundDiv>
          სამწუხაროდ პროდუქტები ვერ მოიძებნა <br />
          <a
            href="#/"
            onClick={e => {
              e.preventDefault()
              clearFilters()
            }}
          >
            ფილტრების გასუფთავება
          </a>
        </NoProductFoundDiv>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <BrowserView>
        <OrderingAndfilters total={pagination?.total} />
      </BrowserView>
      <CategorySale>
        {(products || []).map(product => (
          <ProductItem item={product} />
        ))}
      </CategorySale>
      <Pagination data={pagination} />
      {category.text ? (
        <div
          className="mt-8 format-html"
          dangerouslySetInnerHTML={{ __html: category.text }}
        />
      ) : null}
    </Fragment>
  )
}
